import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/mypos-payment-provider/';

interface DTO {
    parkingId: string;
}

export interface MyPosPaymentProvider {
    id: string;
    public_certificate: string;
    private_key: string;
    store_id: string;
    client_number: string;
    key_index?: number;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId }: DTO): Promise<ListResponseSmartParkAPI<MyPosPaymentProvider>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetMyPOSPaymentProvider, RESOURCE as MyPOS_PAYMENT_PROVIDER_RESOURCE };
